import React from "react";
import { useTranslation } from "react-i18next";
import { Image } from "antd";

export const Cursos = () => {
	const [t] = useTranslation("global");

	const data = [
		{
			date: "04 Jun 2021",
			name: t("js-course"),
			content: t("js-course-desc"),
			image:
				"https://res.cloudinary.com/devsing/image/upload/v1654288810/Portfolio/61078344_k2ik8k.jpg",
		},
		{
			date: "04 Jun 2021",
			name: t("css-course"),
			content: t("css-course-desc"),
			image:
				"https://res.cloudinary.com/devsing/image/upload/v1654288807/Portfolio/61078548_kwps3b.jpg",
		},
		{
			date: "23 Ene 2023",
			name: "React PRO: Lleva tus bases al siguiente nivel",
			content: t("react-pro"),
			image:
				"https://res.cloudinary.com/devsing/image/upload/v1675466676/Portfolio/UC-1898ef02-e37a-4177-9008-83f72b1d07ea_igmkm6.jpg",
		},
	];

	return (
		<>
			<br />
			<br />

			<div className="select-none flex flex-col justify-center items-center my-8 w-screen bg-gray-900 relative overflow-hidden">
				<br />
				<br />
				<br />
				<h2 className="text-center text-yellow-300 font-Montserrat font-bold text-2xl">
					{t("courses")}
				</h2>

				<div className=" flex flex-col justify-center items-center w-96/0">
					{data.map((item, index) => (
						<div key={index}>
							<div className="grid grid-cols-2 w-96/0 mt-5">
								<div className="block tabletbig:flex ">
									<div className="text-center font-Poppins text-yellow-400 font-semibold mx-5 text-1s tabletbig:text-1xl">
										{item.date}
									</div>

									<div className="text-gray-200 font-Poppins mx-5 text-1s tabletbig:text-1xl">
										{item.name}
									</div>
								</div>
								<div className="block tabletbig:flex">
									<div className="tabletbig:w-97">
										<p className="text-gray-400 mb-2 font-Poppins text-smt text-justify">
											{item.content}
										</p>
									</div>
									<div
										style={{
											width: "150px",
											marginLeft: "18px",
										}}
									>
										<Image src={item.image} alt={item.name} loading="lazy" />
									</div>
								</div>
							</div>
							<div className="bg-gray-600 rounded-sm h-0.5 w-screen"></div>
							<br />
						</div>
					))}
				</div>
			</div>
		</>
	);
};
